import { makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { provideState, provideStore } from "@ngrx/store";
import { appStateReducer } from "./state/state";
import { initializeApplication } from "./initialize-app";
import { provideEffects } from "@ngrx/effects";
import { AppEffects } from "./effects/app.effects";
import { provideRouterStore } from "@ngrx/router-store";

export const provideAppState = () => {
  return makeEnvironmentProviders([
    provideStore(),
    provideState({
      name: 'appState',
      reducer: appStateReducer,
    }),
    provideAppInitializer(initializeApplication),
    provideEffects(AppEffects),
    provideRouterStore(),
  ]);
};
